export const TEST_IDS = {
  CONTAINER: 'breadcrumb',
  LIST: 'breadcrumb-list',
  ITEM: 'breadcrumb-item',
  LINK: 'breadcrumb-link',
  PAGE: 'breadcrumb-current',
  SEPARATOR: 'breadcrumb-separator',
  SKELETON: 'breadcrumb-skeleton',
} as const;
